import * as angular from "angular";
import {IQService} from "angular";
import {LabelsAlertsService} from "./labels-alerts.service";
import {LabelsRequestsService} from "./labels-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class LabelsService {

  /* @ngInject */
  constructor(private labelsRequestsService: LabelsRequestsService, private labelsAlertsService: LabelsAlertsService, private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  getAll() {
    const deferred = this.$q.defer();

    this.labelsRequestsService.getAll()
      .then((createdLabel) => {
        deferred.resolve(createdLabel)
      })
      .catch((error) => {
        this.$log.error(error);
        this.labelsAlertsService.getAllError();
        deferred.reject(error)
      });

    return deferred.promise
  }

  createOne(label) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.labelsRequestsService.createOne(label)
      .then((createdLabel) => {
        this.labelsAlertsService.createSuccess();
        deferred.resolve(createdLabel)
      })
      .catch((error) => {
        this.$log.error(error);
        this.labelsAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOne(label) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.labelsRequestsService.updateOne(label)
      .then((updatedLabel) => {
        this.labelsAlertsService.updateOneSuccess(updatedLabel);
        deferred.resolve(updatedLabel)
      })
      .catch((error) => {
        this.$log.error(error);
        this.labelsAlertsService.updateOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.labels')
  .service('labelsService', LabelsService);
